import React from "react";
import PropTypes from "prop-types";
import SvgIcon from "@mui/material/SvgIcon";

export default function ArrowRightAltIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M11.2263 14.239C11.0831 14.0958 11.0102 13.9383 11.0075 13.7662C11.0048 13.5942 11.0751 13.4367 11.2182 13.2935L13.8449 10.6669H4.24868C4.07161 10.6669 3.91623 10.6 3.78255 10.4663C3.64887 10.3326 3.58203 10.1771 3.58203 9.99996C3.58203 9.82279 3.64887 9.66744 3.78255 9.53389C3.91623 9.40035 4.07161 9.33358 4.24868 9.33358H13.8449L11.1974 6.6861C11.0735 6.5636 11.0115 6.41466 11.0115 6.23927C11.0115 6.06388 11.0831 5.90461 11.2263 5.76146C11.3555 5.63218 11.5075 5.56407 11.6822 5.55712C11.8568 5.55018 12.0158 5.61829 12.1589 5.76146L15.8288 9.43133C15.9207 9.52321 15.9861 9.61624 16.0251 9.71044C16.0641 9.80463 16.0836 9.90158 16.0836 10.0013C16.0836 10.101 16.0641 10.1976 16.0251 10.2911C15.9861 10.3846 15.9207 10.4772 15.8288 10.5691L12.1381 14.2598C11.9976 14.403 11.8428 14.4676 11.6738 14.4537C11.5047 14.4399 11.3555 14.3683 11.2263 14.239Z" fill={props.color}/>
      </svg>
    </SvgIcon>
  );
}

ArrowRightAltIcon.propTypes = {
  color: PropTypes.string
};